'use client';

import { CircleIcon } from 'lucide-react';
import { Indicator, Item, Root } from '@radix-ui/react-radio-group';

import type { ComponentProps, JSX } from 'react';

import { cn } from '~/utils';

export function RadioGroup({
  className,
  ...props
}: ComponentProps<typeof Root>): JSX.Element {
  return (
    <Root
      data-slot='radio-group'
      className={cn('grid gap-3', className)}
      {...props}
    />
  );
}

interface IRadioGroupItemProps extends ComponentProps<typeof Item> {
  indicatorIconClassName?: string;
}

export function RadioGroupItem({
  className,
  indicatorIconClassName,
  ...props
}: IRadioGroupItemProps): JSX.Element {
  return (
    <Item
      data-slot='radio-group-item'
      className={cn(
        'text-primary size-3 shrink-0 rounded-full border',
        'bg-blueBonnet-50 dark:bg-input/30 border-blueBonnet-50',
        'focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive aspect-square transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        'data-[state=checked]:border-blueBonnet-500',
        className,
      )}
      {...props}
    >
      <Indicator
        data-slot='radio-group-indicator'
        className='relative flex items-center justify-center'
      >
        <CircleIcon
          className={cn(
            'fill-blueBonnet-500 absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2',
            indicatorIconClassName,
          )}
        />
      </Indicator>
    </Item>
  );
}
